/*eslint no-unused-vars: "off"*/
import React from 'react';
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import Admin from './Admin';
import Splash from './Splash';
// import { Editor } from '@tinymce/tinymce-react';

import Login from './Login';
import Config from './config/app';
import * as FirebaseSDK from 'firebase';
import design from './ui/template/Config';

require("firebase/firestore");

//console.log = function() {}
import firebase from './config/database'
import * as models from './models';
import { init } from '@rematch/core';

// const store = init({
//   models,
//   composeWithDevTools()
// });
const store = init({
  models,
});



// Legacy, local setup
firebase.app = FirebaseSDK.initializeApp(Config.firebaseConfig, "default");
checkLoginStatus();


//AUTHENTICATION
var loggedIn = false;

//CURRENT LANGUAGE
var language = null;
var availableLaguages = [];


function checkLoginStatus() {

  console.log("In index.js");
  firebase.app.auth().onAuthStateChanged(function (user) {
    if (user) {
      // <Editor apiKey='qcweearl49864qamr6avj61zl9g679ha0aqljy9nxi6cre8v' cloudChannel='dev'  init={{ /* your other settings */ }} />

      // User is signed in.
      console.log("User is signed in " + user.email);
      if (Config.adminConfig.adminUsers.indexOf(user.email) === -1) {
        //Error, this user is not allowed anyway
        alert("The user " + user.email + " doens't have access to this admin panel!");
        firebase.app.auth().signOut();
      } else {


        //Update Paths
        for (let index = 0; index < Config.navigation.length; index++) {
          Config.navigation[index].path = Config.navigation[index].path.replace("{useruuid}", user.uid);
          if (Config.navigation[index].subMenus) {
            for (let subIndex = 0; subIndex < Config.navigation[index].subMenus.length; subIndex++) {
              Config.navigation[index].subMenus[subIndex].path = Config.navigation[index].subMenus[subIndex].path.replace("{useruuid}", user.uid);
            }
          }
        }

        loggedIn = true;
        availableLaguages = ["GB"];
        displayApp(user);
      }
    } else {
      console.log("No user is signed in ");
      loggedIn = false;
      displayApp();
      if (window.display) {
        window.display();
      }
    }
  })

}



function displayApp(user) {
  if (loggedIn) {
    render(
      <Provider store={store}>
        <Admin user={user} currentLangData={{
          currentLang: language,
          availableLaguages: availableLaguages,

        }} />
      </Provider>,
      document.getElementById('root')
    )
  } else {
    render(
      <Provider store={store}>
        <Login />
      </Provider>,
      document.getElementById('root')
    )
  }
}
// render(
//   <Provider store={store}>
//     <Splash />
//   </Provider>,
//   document.getElementById('root')
// )



// WEBPACK FOOTER //
// ./src/index.js